import useAuth from 'app/store/auth/useAuth';
import usePermissions from 'app/store/auth/usePermissions';
import { useQuery } from 'react-query';
import { buildPermissionMapper } from '../../store/auth/util';
import { homePageService } from './homePageService';

export const useMenu = () => {
  const {
    isLoading: isLoadingHeaderAndMenu,
    data: dataHeaderAndMenu,
    refetch: refetchGetHeaderAndMenu,
  } = useQuery(['getHeaderAndMenu'], () => homePageService.getHeaderAndMenu(), {
    onSuccess: data => {
      useAuth.getState().setUser(data.user);
      if (Array.isArray(data.menu)) {
        usePermissions.getState().setPermissions(buildPermissionMapper(data.menu));
      }
    },
  });

  return { isLoadingHeaderAndMenu, dataHeaderAndMenu, refetchGetHeaderAndMenu };
};
